export const isEnumValue = <E>(
	enumObj: E,
	value: unknown
): value is E[keyof E] => Object.values(enumObj as any).includes(value as any);
